
export interface EmpresaActual {
  id: number;
  nombreFantasia: string;
  razonSocial: string;
  tipoDocumento: {
    id: number;
  };
  numeroDocumento: string;
  domicilio: string;
  localidad: string;
  departamento: string;
  codigoPostal: string;
  pais: {
    id: number;
  };
  provincia: {
    id: number;
  };
  telefono: string;
  email: string;
  fechaInicioActividad: string;
  puntoVta: string;
  facturaElectronica: boolean;
  tipoResponsableIva: {
    id: number;
  };
  numeroIIBB: string;
  //mpPublicKey: string;
  pathLogoFactura: string;
  creado: string;
  comprobanteLeyenda: string;
  logoComprobanteEncoded: string;
  /*cuenta: {
    id: number;
  };*/
}

export interface EmpresaActualState {
  empresaActual: EmpresaActual | null;
  error: boolean;
  debugMessage?: any;
}

export const initialEmpresaActualState: EmpresaActualState = {
  empresaActual: null,
  error: false,
  debugMessage: null
};
